import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { environment } from '../../../environments/environment';
import { EnvironmentConfig } from '../../../environments/environmentConfig';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdobeAnalyticsDigitalDataService } from 'src/app/service/adobe-analytics-digitaldata.service';
import { encodeConst } from '../../constants';

declare var $: any;
@Component({
  selector: 'cb-consent',
  templateUrl: './cb-consent.component.html',
  styleUrls: ['./cb-consent.component.less'],
  providers: [EnvironmentConfig]
})
export class CBConsentComponent implements OnInit {
  currentLang: string;
  enumData: any;
  cbConsentObj: any = {
    consent_agreed_1: false,
    consent_agreed_2: false
  };
  currentRoutePath: string;
  flow: any;
  productFlow: string;
  isCoApplicantFlowStarted;
  currLangEn = 'en';
  currLangFr = 'fr';
  prequalType = 'P';
  switchType = 'S';
  ipAddress: string;
  applicantName: string;
  preQualData: any;
  applicantName2: string;
  modalOpenCount: number = 0;
  nexpercent: any;
  closeResult: string;
  @ViewChild('content') content: any;
  isIos: boolean;
  isBilingual: boolean = false;
  consentSelected: boolean;
  isSubmitted: boolean = false;
  cbConsentFlag: boolean = false;
  creditCheckLink: any;
  loader: boolean = false;
  popup = 'p';
  isviewedOnce: boolean = false;

  constructor(private _http: HttpClient, private modalService: NgbModal, private util: UtilService,
    private _activatedRoute: ActivatedRoute,
    private i18nService: I18nService,
    private router: Router,
    private translate: TranslateService,
    private adobeAnalyticsData: AdobeAnalyticsDigitalDataService) {
    this.isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    this.util.isSidebarVisible.next(true);
    this.enumData = this.util.getEnumData();
    this.isCoApplicantFlowStarted = this.util.isCoApplicantFlowStarted;
    this.util.sidebarTitle.next('slideTitles.consent');
    let prequalObj = this.util.getSessionStorage();
    if (true) {
      let progressPercent;
      if (prequalObj.is_coapplicant_applied == "Y") {
        progressPercent = prequalObj.users.length == 2 ? CONSTANTS.PROGRESS_PERCENTAGE.CONSENT_CO_APPLICANT : CONSTANTS.PROGRESS_PERCENTAGE.CONCENT_FIRST_APPLICANT;
      }
      else {
        progressPercent = CONSTANTS.PROGRESS_PERCENTAGE.CONCENT_FIRST;
      }
      this.util.progressPercent.next(progressPercent);
      this.nexpercent = progressPercent;
      this.util.isSidebarVisible.next(true);
      sessionStorage.setItem("progressPercentage", String(this.nexpercent))
    }
    else {
    }
    this._activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });
    this.translate.get('cbconsentpage.creditCheckLink').subscribe(res => {
      this.creditCheckLink = res || '';
    })
  }


  ngOnInit(): void {
    this.currentLang = this.i18nService.getCurrentLang();
    this.preQualData = this.util.getSessionStorage();
    this.preQualData.users[0]['tc_consent'] = CONSTANTS.applicationConstants.noVal;
    if (this.preQualData.is_coapplicant_applied === CONSTANTS.applicationConstants.noVal) {
      this.applicantName = this.preQualData.users[0].firstname;
    }
    else {
      this.applicantName = this.preQualData.users[0].firstname;
      this.applicantName2 = this.preQualData.users[1].firstname;
    }

    if (this.isIos) {
      if (sessionStorage.getItem("concentagreed")) {
        this.modalOpenCount = 1;
        if (sessionStorage.getItem("concentagreed") == "true") {
          this.cbConsentObj.consent_agreed = sessionStorage.getItem("concentagreed");
          if (sessionStorage.getItem("setSessionforModal") == "setSessionforModal") {
            document.getElementById("spanToOpenModal12").focus();
          } else {
            document.getElementById("checkboxinp").focus();
          }
          if (sessionStorage.getItem("setSessionforModal") == "setSessionforModal") {
            document.getElementById("spanToOpenModal12").focus();
          } else {
            document.getElementById("checkboxinp").focus();
          }
        }
      }
    }
    this.setIsBiLingualApplicable(this.preQualData);
  }

  /**
   * close cb concent modal
   * created by shubham chaudhari
   *  
   */
  closeModalCbConcent() {
    this.modalService.dismissAll();
    if (this.isIos && !this.isSubmitted) {
      sessionStorage.setItem("concentagreed", this.cbConsentObj.consent_agreed);
      window.location.reload();
    }
    //on closing load for cb consent again

    // add the digital data object again on opening of the modal popup
    if (this.preQualData.flow_type == this.prequalType) {
      var digitalData = this.adobeAnalyticsData.load('cb-consent')
    }
    if (this.preQualData.flow_type == this.switchType) {
      var digitalData = this.adobeAnalyticsData.load('cb-consent?flow=switch')
    }
    if (document.getElementById("adobe-tracking-digital-data")) {
      document.getElementById("adobe-tracking-digital-data").remove();
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalData + "; if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    }

  }

  ngAfterViewInit() {
    if (!this.isIos) {
      if (!sessionStorage.getItem("concentagreed")) {
        document.getElementById("sidebarTitle").focus();
      }
    }
    else {
      if (sessionStorage.getItem("concentagreed")) {
        if (sessionStorage.getItem("setSessionforModal") == "setSessionforModal") {
          document.getElementById("spanToOpenModal12").focus();
          sessionStorage.removeItem("setSessionforModal");
        } else {
          document.getElementById("checkboxinp").focus();
        }
      } else {
        document.getElementById("sidebarTitle").focus();
      }
    }
  }

  /**
   * open cb concent popup
   * created by shubham chaudhari
   *  
   * @param content 
   */
  open(content) {
    if (!this.isviewedOnce) {
      this.isviewedOnce = true;
      this.modalOpenCount++;
    }
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl', backdrop: 'static' }).result.then((result) => {
      $("#checkboxinp").focus();
    }, (reason) => {
      $("#checkboxinp").focus();
    });
    // add the digital data object again on opening of the modal popup
    if (this.preQualData.flow_type == this.prequalType) {
      var digitalData = this.adobeAnalyticsData.load('terms-and-conditions');
    }
    else if (this.preQualData.flow_type == this.switchType) {
      var digitalData = this.adobeAnalyticsData.load('terms-and-conditions?flow=switch');
    }

    if (document.getElementById("adobe-tracking-digital-data")) {
      document.getElementById("adobe-tracking-digital-data").remove();
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalData + "; if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    }

  }


  /**
   * this fuction get called when user clicks on continue button
   * created by shubham chaudhari
   * 
   */

  onContinue(page: any) {
    if (page == this.popup) {
      this.isSubmitted = true;
      if (this.modalOpenCount > 3) {
        this.preQualData.failure_code = CONSTANTS.applicationConstants.consentFailureCode;
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
      else {
        this.saveCbDetails();
      }
    }
    else {
      if (this.isviewedOnce) {
        if (this.preQualData.is_coapplicant_applied === CONSTANTS.applicationConstants.noVal && !this.cbConsentObj.consent_agreed_1) {
          this.modalOpenCount++;
        }
        else if ((this.preQualData.is_coapplicant_applied === CONSTANTS.applicationConstants.yesVal) && !(this.cbConsentObj.consent_agreed_1 && this.cbConsentObj.consent_agreed_2)) {
          this.modalOpenCount++;
        }
      }
      if (this.modalOpenCount > 3) {
        this.preQualData.failure_code = CONSTANTS.applicationConstants.consentFailureCode;
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
      else {
        this.open(this.content);
      }
    }
  }
  saveCbDetails() {
    const newObj = {
      "preQualify_mortgage_amount": 0,
      "preQualify_purchase_price": 0,
      "preQualify_mortgage_reference_number": null,
      "cmhc_default_insurance": 0,
      "total_mortgage_amount": 0,
      "down_payment": 0,
    }
    this.preQualData = {
      ...this.preQualData, ...newObj
    }
    if (this.preQualData.is_coapplicant_applied === CONSTANTS.applicationConstants.noVal && this.cbConsentObj.consent_agreed_1) {
      this.preQualData.users[0].cb_consent = CONSTANTS.applicationConstants.yesVal;
      this.util.setSessionStorage(this.preQualData);
      this.cbConsentFlag = true;
    }
    else if (this.cbConsentObj.consent_agreed_1 && this.cbConsentObj.consent_agreed_2) {
      this.preQualData.users[1].cb_consent = CONSTANTS.applicationConstants.yesVal;
      this.preQualData.users[0].cb_consent = CONSTANTS.applicationConstants.yesVal;

      this.util.setSessionStorage(this.preQualData);
      this.cbConsentFlag = true;
    }
    try {
      if (this.cbConsentFlag) {
        this.close();
        this.loader = true;
        if (environment.ipifyEnabled != "true") {
          this._http.get(environment.api.getIpUrl).subscribe((res: any) => {
            this.ipAddress = res.ip;
            this.preQualData.users.forEach((_, i) => {
              this.preQualData.users[i].ip_address = this.ipAddress;
              this.preQualData.users[i].cb_datetime = this.util.getUTCDateTime();
            })
            this.util.setSessionStorage(this.preQualData);
            this.saveconsent();

          }, (err) => {
            this.loader = false;
            this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          });
        }
        else {
          this.saveconsent();
        }
      }
      else {
        this.consentSelected = false;

        if (this.preQualData.flow_type == this.switchType) {
          this.util.adobeAnalyticalErrorMsg("cb-consent-check", "missing", null);
        }


      }
    } catch (e) {
    }
  }
  /**
   * this function opens modal if user directly click on continue button without open modal
   * created by shubham chaudhari
   *  
   * @param conditionallyOpened if modal is opend or not
   * @param content modal content html 
   */
  openModal(flag, content?: any) {

    if (this.preQualData.is_coapplicant_applied === CONSTANTS.applicationConstants.noVal && this.cbConsentObj.consent_agreed_1) {
      this.open(content);
    }
    else if (this.cbConsentObj.consent_agreed_1 && this.cbConsentObj.consent_agreed_2) {

      this.open(content);
    }
    else if (flag === true) {
      if (this.isviewedOnce) {
        this.modalOpenCount++;
      }
      if (this.modalOpenCount > 3) {
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      }
      else {
        this.open(content);
      }

    }

  }
  /**
   * on refresh this function will be called
   * created by shubham chaudhari
   *  
   * @param input 
   */
  setSessionforModal(input) {
    sessionStorage.setItem("setSessionforModal", "setSessionforModal");
  }
  /**
   * Get ip address of system
   * created by shubham chaudhari
   *  
   */
  getIPAddress() {
    this._http.get(environment.api.getIpUrl).subscribe((res: any) => {
      this.ipAddress = res.ip;
    }, (err) => {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    });
  }
  saveconsent() {
    let preQualData = this.util.getSessionStorage();
    this.consentSelected = true;
    if (this.preQualData.flow_type == this.prequalType) {
      this.util.saveJson(preQualData).subscribe(res => {
        this.util.getDMRespone(res).subscribe((response: any) => {
          this.loader = false;
          this.util.setSessionStorage(response);
          if (response.error_description === CONSTANTS.applicationConstants.createProspectFailed || response.status.toLowerCase() == CONSTANTS.applicationConstants.declined || !response.prequal_slider) {
            this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          } else {
            sessionStorage.setItem("startTimer for summaryPage", "true")
            this.router.navigate(['../summary'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          }
        }, (err) => {
          this.loader = false;
          this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
        });
      }, (err) => {
        this.loader = false;
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      });

    }
    else {
      let preQualData = this.util.getSessionStorage();
      this.util.saveJson(preQualData).subscribe(response => {
        this.util.getLiabilities(response).subscribe((res: any) => {
          this.loader = false;
          if (res.error_description === CONSTANTS.applicationConstants.createProspectFailed || res.status.toLowerCase() == CONSTANTS.applicationConstants.declined) {
            this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          }
          else {
            this.util.setSessionStorage(res);
            this.router.navigate(['../estimated_value_of_home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
          }
        }, (err) => {
          this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
        });
      }, (err) => {
        this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
      });
    }
  }



  saveDetails(preQualObj: any) {
    $("#cbcnsent").modal("hide");
    if (this.preQualData.is_coapplicant_applied) {
      this.preQualData.users[0]['cbConsent'] = this.cbConsentObj.consent_agreed_1;
      this.preQualData.users[1]['cbConsent'] = this.cbConsentObj.consent_agreed_2;
      this.util.setSessionStorage(this.preQualData);
    }
    else {
      this.preQualData.users['cbConsent'] = this.cbConsentObj.consent_agreed_1;
      this.util.setSessionStorage(this.preQualData);
    }


    this.router.navigate([this.util.determineNextRoute(this.currentRoutePath)], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });

    this.util.saveJson(preQualObj).subscribe(data => {
      this.router.navigate([this.util.determineNextRoute(this.currentRoutePath)], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }, (error) => {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    });
  }

  /**
   * CR-16 
   * This fn checks user address & lang to enable bilingual T&C 
   * @param prequalObj users data object
   */
  setIsBiLingualApplicable(prequalObj) {
    if (prequalObj && prequalObj.lang_pref && prequalObj.lang_pref.toLowerCase() === CONSTANTS.applicationConstants.en &&
      Array.isArray(prequalObj.users) && prequalObj.users[prequalObj.users.length - 1] &&
      prequalObj.users.some(user => user.province.toUpperCase() === CONSTANTS.applicationConstants.QC)) {
      this.isBilingual = true;
    } else {
      this.isBilingual = false;
    }
  }
  close() {
    if (this.cbConsentFlag) {
      this.closeModalCbConcent();
    }
  }

}
